import { render, staticRenderFns } from "./payback.vue?vue&type=template&id=f99dbab0&scoped=true"
import script from "./payback.vue?vue&type=script&lang=js"
export * from "./payback.vue?vue&type=script&lang=js"
import style0 from "./payback.vue?vue&type=style&index=0&id=f99dbab0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99dbab0",
  null
  
)

export default component.exports